var map = {
	"./1.png": "426c",
	"./10.png": "9a4e",
	"./11.png": "02d2",
	"./12.png": "ffcb",
	"./13.png": "c964",
	"./14.png": "c8b8",
	"./15.png": "20ec",
	"./2.png": "c61f",
	"./3.png": "6dde",
	"./4.png": "f168",
	"./5.png": "9828",
	"./6.png": "1a14",
	"./7.png": "f68a",
	"./8.png": "d603",
	"./9.png": "4e84",
	"./page_1.png": "7380",
	"./page_10.png": "d3e6",
	"./page_11.png": "7566",
	"./page_12.png": "ce04",
	"./page_13.png": "6869",
	"./page_14.png": "16b0",
	"./page_15.png": "de36",
	"./page_2.png": "07e1",
	"./page_3.png": "62e5",
	"./page_4.png": "f406",
	"./page_5.png": "f5dd",
	"./page_6.png": "c789",
	"./page_7.png": "59cb",
	"./page_8.png": "d14d",
	"./page_9.png": "087d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "56f3";